import React from 'react';
import { FileText, Plus } from 'lucide-react';
interface SopPlaceholderProps {
  title: string;
  description: string;
}
export function SopPlaceholder({
  title,
  description
}: SopPlaceholderProps) {
  return <div className="my-4 flex items-center justify-between rounded-lg border bg-card p-4 shadow-sm transition-all hover:shadow-md" data-id="element-249">
      <div className="flex items-start gap-4" data-id="element-250">
        <div className="rounded-lg bg-primary/10 p-2 text-primary" data-id="element-251">
          <FileText className="h-5 w-5" data-id="element-252" />
        </div>
        <div data-id="element-253">
          <h4 className="font-medium text-foreground" data-id="element-254">{title}</h4>
          <p className="text-sm text-muted-foreground" data-id="element-255">{description}</p>
        </div>
      </div>
      <button className="flex items-center gap-2 rounded-md border bg-background px-3 py-1.5 text-sm font-medium text-foreground hover:bg-muted transition-colors" data-id="element-256">
        <Plus className="h-4 w-4" data-id="element-257" />
        <span className="hidden sm:inline" data-id="element-258">Attach SOP</span>
      </button>
    </div>;
}